export default __webpack_public_path__ + "static/media/plane-down.11ebe630.svg";